import { WorkType as WorkTypeEnum, ReviewStatus } from 'src/enums/work';
import { QuestStatus } from 'src/enums/quests';

export const getWorkTypeName = (workTypeValue: WorkTypeEnum): string => {
    const workTypeKey = Object.keys(WorkTypeEnum).find(
        (key) =>
            WorkTypeEnum[key as keyof typeof WorkTypeEnum] === workTypeValue
    );
    return workTypeKey
        ? workTypeKey.toLowerCase().replace(/_/g, ' ')
        : 'unknown';
};

export const getReviewStatusName = (
    reviewStatusValue: ReviewStatus
): string => {
    const reviewStatusKey = Object.keys(ReviewStatus).find(
        (key) =>
            ReviewStatus[key as keyof typeof ReviewStatus] === reviewStatusValue
    );
    return reviewStatusKey
        ? reviewStatusKey.toLowerCase().replace(/_/g, ' ')
        : 'unknown';
};

export const getQuestCreatedText = (
    status?: QuestStatus,
    implementationPlanRequired?: boolean,
    quickQuest?: boolean,
    user?: string
): string => {
    let text = 'created the request';
    if (status === QuestStatus.ON_HOLD) {
        text += ' in the Backlog';
    }
    if (implementationPlanRequired) {
        text += ' and requested an implementation plan';
    } else if (user !== 'Client' && quickQuest) {
        text += ' and it was marked as a quick quest';
    }
    return text;
};
